import ContentWrapper from 'Component/ContentWrapper';
import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Form from 'Component/Form';
import Loader from 'Component/Loader';
import TypographyHeader from 'Component/TypographyHeader';
import { PasswordChangePage as SourcePasswordChangePage } from 'SourceRoute/PasswordChangePage/PasswordChangePage.component';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

import './PasswordChangePage.override.style';

/** @namespace Advox/Route/PasswordChangePage/Component */
export class PasswordChangePage extends SourcePasswordChangePage {
    renderForm() {
        const { onPasswordSuccess, onError, passwordMinLength, passwordClassesLength } = this.props;

        return (
            <Form key="reset-password" onSubmit={onPasswordSuccess} onError={onError}>
                <Field
                    type={FIELD_TYPE.password}
                    label={__('New password')}
                    attr={{
                        id: 'new-password',
                        name: 'password',
                        placeholder: __('Enter your password...'),
                        autocomplete: 'new-password',
                    }}
                    validateOn={['onChange']}
                    validationRule={{
                        isRequired: true,
                        inputType: VALIDATION_INPUT_TYPE.password,
                        match: () => {
                            const passwordConfirmation = document.getElementById('password_confirmation');
                            if (passwordConfirmation.value) {
                                passwordConfirmation.dispatchEvent(new Event('validate', { bubbles: true }));
                            }

                            // In this case, return always true, but trigger validate on other field (password_confirmation)
                            return true;
                        },
                        matchPassword: {
                            passwordClassesLength,
                        },
                        range: {
                            min: passwordMinLength,
                        },
                    }}
                    addRequiredTag
                />
                <Field
                    type={FIELD_TYPE.password}
                    label={__('Retype password')}
                    attr={{
                        id: 'password_confirmation',
                        name: 'password_confirmation',
                        placeholder: __('Retype your password...'),
                        autocomplete: 'new-password',
                    }}
                    validateOn={['onChange']}
                    validationRule={{
                        isRequired: true,
                        inputType: VALIDATION_INPUT_TYPE.password,
                        match: (value) => {
                            const password = document.getElementById('new-password');
                            return password.value === value;
                        },
                        customErrorMessages: {
                            onMatchFail: __('Passwords do not match!'),
                        },
                    }}
                    addRequiredTag
                />
                <div block="MyAccount" elem="Buttons">
                    <button type="submit" block="PasswordChangePage" elem="Button" mix={{ block: 'Button' }}>
                        {__('Update Password')}
                    </button>
                </div>
            </Form>
        );
    }

    render() {
        const { isLoading } = this.props;

        return (
            <main block="PasswordChangePage" aria-label={__('Password Change Page')}>
                <ContentWrapper
                    mix={{ block: 'PasswordChangePage' }}
                    wrapperMix={{ block: 'PasswordChangePage', elem: 'Wrapper' }}
                    label="Password Change Actions"
                >
                    <Loader isLoading={isLoading} />

                    <TypographyHeader variant="medium" tag="h2" fontWeight="medium">
                        {__('Change My Password')}
                    </TypographyHeader>
                    {this.renderForm()}
                </ContentWrapper>
            </main>
        );
    }
}

export default PasswordChangePage;
